import { Component, OnInit } from '@angular/core';
declare var $:any;
declare var iziToast:any;
@Component({
  selector: 'app-biz-file-upload',
  templateUrl: './biz-file-upload.component.html',
  styleUrls: ['./biz-file-upload.component.css']
})
export class BizFileUploadComponent implements OnInit {
  file_data;
  constructor() { }

  ngOnInit(): void {
    $(document).on("click", ".browse", function() {
      var file = $(this)
        .parent()
        .parent()
        .parent()
        .find(".file");
      file.trigger("click");
    });
    $(document).on("change", ".file", function() {
      $(this)
        .parent()
        .find(".form-control")
        .val(
          $(this)
            .val()
            .replace(/C:\\fakepath\\/i, "")
        );
    });
    
  }
  fileChange(event) {
    this.file_data = event.target.files[0];
    console.log(this.file_data)

  //   console.log();
  //   return false;
  //   item.binary = event;
  //   var r = new FileReader();
  //   r.onload = function(e) { 
  //     item.binary = r.result
  //   }
  //  var k = r.readAsArrayBuffer(event.target.files[0]);
  //   console.log(k)
  }
submit(){
  let access_token: any=localStorage.getItem('at');
    let customer_id: any=localStorage.getItem('en');
  const forms = new FormData();
        forms.append('operation', 'curlData');
        forms.append('moduleType', 'profile');
        forms.append('api_type', 'web');
        forms.append('action', 'update_biz_file');
        forms.append('access_token', access_token);
        forms.append('customer_id', customer_id);
        forms.append('attachment', this.file_data);
        var self = this;
        $.ajax({
              // url: "https://dev.cal4care.com/erp/data-services-check/index.php",
              url: "https://erp.cal4care.com/cms_new/api_cms/v1.0/index_new.php",
              type: 'POST',
              data: forms,
              processData: false,
              contentType: false,
              success: function (data) {
              var data = JSON.parse(data);
              console.log(data);
              if(data.status=='true'){
                iziToast.success({
                  message: "BIZ File Uploaded successfully",
                  position: 'topRight'
              });
             
              }else{
                iziToast.error({
                  message: "Some Error occur Please Try Again Later",
                  position: 'topRight'
              });
              }
              }
          });
}
}
